// The coin flip at the start of the first match of a room. The die has four
// sun faces and four moon faces, and it lands on the side of this screen. The
// side of Sun moves first. Garrett, 2026-10-13: "coin flip to start (maybe
// roll die with half / half faces icons?)". The server picks the sides. The
// die only shows what it picked.

import { COIN_FLIP_REST_MS, DIE_SPIN_MS, REDUCED_MOTION_QUERY } from '../constants';
import type { Side } from '../engine/types';
import { createStore } from '../lib/store';

/** The side the die lands on, while the flip shows. `spectator` changes the words. */
export type CoinFlip = { side: Side; spectator: boolean };

export const coinFlipStore = createStore<CoinFlip | null>(null);

/** Shows the flip, and resolves when it is gone. */
export const playCoinFlip = (side: Side, spectator: boolean): Promise<void> =>
  new Promise((resolve) => {
    coinFlipStore.set({ side, spectator });
    const spin = window.matchMedia(REDUCED_MOTION_QUERY).matches ? 0 : DIE_SPIN_MS;
    window.setTimeout(() => {
      coinFlipStore.set(null);
      resolve();
    }, spin + COIN_FLIP_REST_MS);
  });
